import React, { useEffect, useState, useCallback } from 'react'

import {
    getCustomerCities,
    getCustomerCountries,
    getCustomerStates
} from 'utlis/Apis/Customers_API';

export default function AddressBox(props) {
    // props
    const {
        dataItem
    } = props

    return (
        <div className="frac">
            <div className="frac-inner h-100 d-flex flex-column">
                <p className="st-fw-800 mb-1">
                    {dataItem.firstName} {dataItem.lastName}
                </p>
                <p className="mb-1">
                    {dataItem.address}
                </p>
                <p className="mb-1">
                    {dataItem.city} {dataItem.state}, {dataItem.zipCode}
                </p>
                <p className="mb-1">
                    {dataItem.phone}
                </p>
                <p className="mb-1">
                    {dataItem.isDefault}
                </p>
                <p className="mb-1">
                    {dataItem.addressType}
                </p>

                <div className="links d-flex mt-auto pt-2">
                    <a href="/" className="d-flex align-items-center me-2">
                        <span>Edit</span>
                    </a>
                    <a href="/" className="d-flex align-items-center me-2">
                        <span>Delete</span>
                    </a>
                    {
                        dataItem.isDefault ? (
                            <a href="/" className="d-flex align-items-center me-2 text-decoration-none" style={{ pointerEvents: 'none' }}>
                                <span>Default Address</span>
                            </a>
                        ) : (
                            <a href="/" className="d-flex align-items-center me-2">
                                <span>Make Default</span>
                            </a>
                        )
                    }
                </div>
            </div>
        </div>
    )
}
